import { render, staticRenderFns } from "./report-tag-edit.vue?vue&type=template&id=7bc9280a"
import script from "./report-tag-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./report-tag-edit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports